<template>
  <div class="feedback-container">
    <div v-for="item in users" :key="item.name" class="feedback-card"
      :class="{ 'unified-contact': item.post === 'Единый контакт' }">
      <div class="card-header">
        <span class="quest-tag">{{ item.quest }}</span>
        <h3 class="post-title">{{ item.post }}</h3>
      </div>

      <div class="card-body">
        <div v-if="item.name" class="contact-person">
          <svg class="icon" viewBox="0 0 24 24" width="16" height="16">
            <path fill="currentColor"
              d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
          </svg>
          <span class="name">{{ item.name }}</span>
        </div>

        <div class="contact-info">
          <div v-if="item.phone" class="phone">
            <svg class="icon" viewBox="0 0 24 24" width="16" height="16">
              <path fill="currentColor"
                d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
            </svg>
            <span>{{ item.phone }}</span>
          </div>

          <div v-if="item.mail" class="email">
            <svg class="icon" viewBox="0 0 24 24" width="16" height="16">
              <path fill="currentColor"
                d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,2.89 21.1,4 20,4Z" />
            </svg>
            <a :href="'mailto:' + item.mail" class="email-link">{{ item.mail }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="guide-links">
    <div class="guide-link" @click="onClickFile('КРОН-ТМ WEB - Руководство администратора.pdf')">
      <i class="pi pi-file-pdf" style="font-size: 1.25rem"></i>
      <span>Руководство администратора</span>
    </div>

    <div class="guide-link" @click="onClickFile('КРОН-ТМ WEB - Руководство пользователя.pdf')">
      <i class="pi pi-file-pdf" style="font-size: 1.25rem"></i>
      <span>Руководство пользователя</span>
    </div>
  </div>
</template>

<script setup>

const users = [
  {
    quest: 'Вопросы по работе системы',
    post: 'Единый контакт',
    name: '',
    phone: '8(8553)30-58-56, 8(8553)30-58-55, 89196807630, 8(8553)39-30-18',
    mail: 'kron@cdisoft.ru',
  },
  {
    quest: 'Вопросы по работе системы',
    post: 'Системный инженер',
    name: 'Нигматзянова Регина Радистовна',
    phone: '89172696723, 305855',
    mail: 'nigmatzyanovarr@cdisoft.ru',
  },
  {
    quest: 'Вопросы по работе системы',
    post: 'Системный инженер',
    name: 'Мустакимова Раушания Радистовна',
    phone: '89196807630',
    mail: 'mustakimovarr@cdisoft.ru',
  },
  {
    quest: 'Вопросы по работе системы',
    post: 'Инженер-программист',
    name: 'Зарипов Дамир Ринатович',
    phone: '89178813191',
    mail: 'zaripovdr@cdisoft.ru',
  },
  {
    quest: 'Организационные вопросы',
    post: 'Начальник отдела производственного ПО',
    name: 'Маланьин Максим Владимирович',
    phone: '8(8553)393919',
    mail: 'malaninmv@cdisoft.ru',
  },
  {
    quest: 'Вопросы по работе системы',
    post: 'Инженер-программист',
    name: 'Воробьев Андрей Николаевич',
    phone: '8(8553)305857',
    mail: 'vorobyevan@cdisoft.ru',
  },
  {
    quest: 'Вопросы по работе системы',
    post: 'Инженер-программист',
    name: 'Симатов Руслан Леонидович',
    phone: '8(8553)305860',
    mail: 'simatovrl@cdisoft.ru',
  },
];

const onClickFile = (name) => {
  const link = document.createElement('a');
  link.href = `./guide/${name}`;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<style lang="scss" scoped>
.feedback-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1.5rem;
  margin: 0 auto;
}

.feedback-card {
  background: var(--surface-card);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  box-shadow: var(--card-shadow);
  border: 1px solid var(--surface-border);
  transition: all 0.3s ease;
  flex: 1 1 300px;
  max-width: 400px;
  min-width: 280px;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--focus-ring);
    border-color: var(--primary-color);
  }

  &.unified-contact {
    border-left: 4px solid var(--primary-color);
    background: var(--highlight-bg);

    .quest-tag {
      background: linear-gradient(135deg, var(--cyan-400) 0%, var(--primary-color) 100%);
      color: var(--primary-color-text);
    }

    .post-title {
      color: var(--surface-900);
    }
  }
}

.card-header {
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--surface-border);
}

.quest-tag {
  display: inline-block;
  background: linear-gradient(135deg, var(--blue-400) 0%, var(--primary-color) 100%);
  color: var(--primary-color-text);
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  letter-spacing: 0.3px;
}

.post-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--surface-900);
  margin: 0;
  line-height: 1.4;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-grow: 1;
}

.contact-person {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin-bottom: 0.5rem;

  .icon {
    color: var(--surface-600);
    flex-shrink: 0;
  }

  .name {
    font-size: 1rem;
    font-weight: 600;
    color: var(--surface-900);
    line-height: 1.4;
  }
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: auto;
}

.phone,
.email {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.5;

  .icon {
    color: var(--surface-600);
    margin-top: 0.125rem;
    flex-shrink: 0;
  }

  span,
  a {
    color: var(--surface-700);
    word-break: break-word;
  }
}

.email-link {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--primary-600);
    text-decoration: underline;
  }
}

.guide-links {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
  padding: 0 1.5rem;
  width: 100%;
}

.guide-link {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: 1rem 1.25rem;
  color: var(--surface-900);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9375rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: var(--card-shadow);
  flex: 1 1 calc(50% - 0.5rem);
  min-width: 280px;
  max-width: 400px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--focus-ring);
    border-color: var(--primary-color);
    background: var(--highlight-bg);
    color: var(--primary-color);

    i {
      color: var(--primary-color);
      transform: translateY(-1px);
    }
  }

  i {
    color: var(--surface-600);
    transition: all 0.3s ease;
    font-size: 1.25rem;
  }

  span {
    flex-grow: 1;
    line-height: 1.4;
  }
}

@media (max-width: 768px) {
  .feedback-container {
    padding: 1rem;
    gap: 1rem;
  }

  .feedback-card {
    flex: 1 1 100%;
    max-width: 100%;
    padding: 1.25rem;
  }

  .guide-links {
    padding: 0 1rem;
    gap: 0.75rem;
  }

  .guide-link {
    flex: 1 1 100%;
    max-width: 100%;
    padding: 0.875rem 1rem;
  }
}

@media (max-width: 480px) {
  .feedback-card {
    padding: 1rem;
  }

  .post-title {
    font-size: 1rem;
  }

  .name {
    font-size: 0.9375rem;
  }

  .guide-link {
    padding: 0.75rem;
    font-size: 0.875rem;

    i {
      font-size: 1.125rem;
    }
  }
}
</style>